import * as React from 'react';
import { Svg } from '../svg';

function SvgAlertPost({ title, titleId, ...props }, svgRef) {
  return (
    <Svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <rect width={24} height={24} rx={12} fill="#F63" />
      <path
        d="M12 18.666a6.667 6.667 0 100-13.333 6.667 6.667 0 000 13.333zM12 9.333V12M12 14.667h.007"
        stroke="#fff"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

const ForwardRef = React.forwardRef(SvgAlertPost);
export default ForwardRef;
